module.exports = __webpack_public_path__ + "components/flag/static/square/lu-ba70cec0f2685250b8c904807dfb5b8b.svg";